"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var DialogTitle = function DialogTitle(_ref) {
  var rootClass = _ref.rootClass,
      text = _ref.text,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    disableTypography: true,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, text);
};

var _default = DialogTitle;
exports.default = _default;
DialogTitle.propTypes = {
  text: _propTypes.default.string.isRequired,

  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
DialogTitle.defaultProps = {
  rootClass: [],
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};